import React from 'react';
import {
  Box, Paper, TextField, Typography, Button, Chip
} from '@mui/material';
import {
  FolderOpen as FolderIcon, Close as CloseIcon
} from '@mui/icons-material';
import { useTranslation } from 'react-i18next';

const FormInfo = ({ 
  formTitle, 
  formDescription, 
  onUpdateFormDetails, 
  userData, 
  selectedFolderIds, 
  setSelectedFolderIds, 
  folderOptions, 
  onFolderDialogOpen 
}) => {
  const { t } = useTranslation();

  return (
    <Paper sx={{ 
      p: 2, 
      mb: 2,
      borderRadius: 2,
      border: '1px solid #e2e8f0',
      boxShadow: '0 1px 3px rgba(0,0,0,0.05)',
      background: 'linear-gradient(to bottom right, #ffffff, #f8fafc)'
    }}>
      {/* Logo alanı */}
      <Box sx={{ mb: 2, display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
        {userData?.logoUrl ? (
          <Box sx={{ 
            position: 'relative', 
            width: '150px', 
            height: '75px', 
            mb: 1,
            border: '1px solid #e2e8f0',
            borderRadius: '8px',
            overflow: 'hidden',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            bgcolor: '#f8fafc'
          }}>
            <img 
              src={userData.logoUrl} 
              alt={userData?.companyName || 'Şirket logosu'} 
              style={{ 
                width: '100%', 
                height: '100%', 
                objectFit: 'contain' 
              }} 
            />
          </Box>
        ) : (
          <Box sx={{
            width: '150px',
            height: '75px',
            mb: 1,
            border: '2px dashed #e2e8f0',
            borderRadius: '8px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            bgcolor: '#f8fafc',
            color: '#64748b'
          }}>
            <Typography variant="body2" sx={{ textAlign: 'center' }}>
              {t('no_logo_available')}
            </Typography>
          </Box>
        )}
      </Box>

      <TextField
        fullWidth
        label={t('form_title')}
        value={formTitle}
        onChange={(e) => onUpdateFormDetails('title', e.target.value)}
        variant="outlined"
        size="small"
        sx={{ 
          mb: 1.5,
          '& .MuiOutlinedInput-root': {
            borderRadius: '8px',
            '&:hover fieldset': {
              borderColor: '#1976d2'
            }
          }
        }}
      />
      <TextField
        fullWidth
        label={t('form_description')}
        value={formDescription}
        onChange={(e) => onUpdateFormDetails('description', e.target.value)}
        variant="outlined"
        multiline
        rows={2}
        size="small"
        sx={{ 
          mb: 1.5,
          '& .MuiOutlinedInput-root': {
            borderRadius: '8px',
            '&:hover fieldset': {
              borderColor: '#1976d2'
            }
          }
        }}
      />
      
      {/* Klasör Seçimi Alanı */}
      <Box sx={{ mb: 1 }}>
        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 1 }}>
          <Typography variant="subtitle2" sx={{ color: '#1e293b', fontWeight: 600 }}>{t('folders')}</Typography>
          <Button 
            variant="outlined" 
            startIcon={<FolderIcon />}
            onClick={onFolderDialogOpen}
            size="small"
            sx={{
              borderRadius: '8px',
              borderColor: '#e2e8f0',
              color: '#64748b',
              '&:hover': {
                borderColor: '#1976d2',
                color: '#1976d2',
                backgroundColor: 'rgba(25, 118, 210, 0.04)'
              }
            }}
          >
            {t('add_to_folder')}
          </Button>
        </Box>
        
        {selectedFolderIds.length > 0 ? (
          <Box sx={{ 
            display: 'flex', 
            flexWrap: 'wrap', 
            gap: 0.5, 
            p: 1,
            borderRadius: '8px',
            border: '1px solid',
            borderColor: '#e2e8f0',
            bgcolor: '#ffffff'
          }}>
            {selectedFolderIds.map(value => {
              const folder = folderOptions.find(opt => opt.value === value);
              return folder ? (
                <Chip 
                  key={value} 
                  label={folder.label}
                  size="small"
                  deleteIcon={<CloseIcon fontSize="small" />}
                  onDelete={() => {
                    setSelectedFolderIds(prev => prev.filter(id => id !== value));
                  }}
                  sx={{
                    fontWeight: 500,
                    borderRadius: '6px',
                    '&:hover': {
                      bgcolor: '#f1f5f9',
                    },
                    '& .MuiChip-deleteIcon': {
                      color: '#64748b',
                      '&:hover': {
                        color: '#1976d2'
                      }
                    }
                  }}
                />
              ) : null;
            })}
          </Box>
        ) : (
          <Typography variant="body2" color="text.secondary" sx={{ mt: 0.5 }}>
            {t('no_folder_selected')}
          </Typography>
        )}
      </Box>
    </Paper>
  );
};

export default FormInfo;
